
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OMSProvider } from './context/OMSContext';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//Changes for React 18
const rootElement = document.getElementById('root');
const root = createRoot(rootElement); 

root.render(
    <AuthProvider>
        <BrowserRouter basename={baseUrl}>
            <OMSProvider>  
            <App />
            </OMSProvider>
        </BrowserRouter>
    </AuthProvider>);
registerServiceWorker();
